import Mobile from "./find-a-lab-mobile";
import Desktop from "./map_view";
import { useUI } from "../../../context/UIContext";

export default function FindALab() {
  const { is_mobile } = useUI();
  return <>{is_mobile ? <Mobile /> : <Desktop />}</>;
}
